import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import ImportData from '../../../../components/import-data';


// Import Selectors
import { getUser, getUserCurrentOrganization } from '../../../Auth/AuthReducer';

class OrganizationImportPage extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  render() {
    const { organization } = this.props;
    const isDemo = organization && organization.is_demo;
    return (
      <div>
        <Helmet title="Import Data | Organization Setup" />
        <div className="container">
          {isDemo && <div className="alert alert-warning">Cannot import data for demo organization</div>}
          {!isDemo && <div><ImportData chunks={true} /></div>}
          <div style={{ height: '100px' }}></div>
        </div>
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    organization: getUserCurrentOrganization(state),
  };
}

OrganizationImportPage.propTypes = {
  user: PropTypes.object.isRequired,
  organization: PropTypes.shape({}),
};

OrganizationImportPage.defaultProps = {
};

OrganizationImportPage.contextTypes = {
  router: PropTypes.shape({}),
};

export default connect(mapStateToProps)(OrganizationImportPage);
